import styled from 'styled-components'
import {spacing} from '../../../../../theme/spacing'

export const ButtonsArea = styled.div`
    display: flex;
    flex-direction: row;
    column-gap: ${spacing(4)};
`
